//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            type: Object,
            default: () => ({
                url: '',
                file: ''
            })
        },
        accept: {
            type: String,
            default: ''
        },
        fileName: {
            type: String,
            default: ''
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            upload: this.value,
        };
    },

    watch: {
        upload () {
            this.$emit('input', this.upload);
        },
        value () {
            this.upload = this.value;
        }
    },

    methods: {
        deleteFile () {
            this.upload.url = '';
            this.upload.file = '';
        },
        selectFile (file) {
            this.upload.url = URL.createObjectURL(file.raw);
            this.upload.file = file;
        },
        uploadFile () {
            if (this.$listeners && this.$listeners.upload) {
                this.$emit('upload', this.upload);
                this.upload.url = '';
                this.upload.file = '';
            }
        }
    }
};
